export const NotImplemented = () => {
  throw Error('Not implemented');
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const Empty = () => {};
